import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { IonicModule } from '@ionic/angular';

@Component({
    standalone: true,
    selector: 'lib-control-error',
    templateUrl: './control-error.component.html',
    styleUrls: ['./control-error.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [IonicModule],
})
export class ControlErrorComponent {
    private currentText: string | undefined;

    public constructor(private changeDetector: ChangeDetectorRef) {}

    public get errorText(): string | undefined {
        return this.currentText;
    }

    public set errorText(error: string | undefined) {
        this.currentText = error;
        this.changeDetector.detectChanges();
    }
}
